import axios from '../../utils/axiosConfig';
import axiosraw from 'axios';

import config from '../../utils/Config';

let getEnrollmentPageDate =  (enrollmentData) => {
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'enrollment/getenrollmentpagedata', enrollmentData).then(result => {
            resolve(result)
        }).catch((err) => {

            if(err && err.response && err.response.data && err.response.data && err.response.data.message){
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to fetch enrollment data"
                })
            }
        })
    })
}

let saveEnrollmentPageData = (enrollmentData) => {
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'enrollment/saveenrollmentpagedata', enrollmentData).then(result => {
            resolve(result)
        }).catch((err) => {
            
            if(err && err.response && err.response.data && err.response.data && err.response.data.message){
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to submit enrollment data"
                })
            }
        })
    })
}
//{"districtId": "646f477e175d2249b52d0b77"}
let getEnrollmentPageDatePDF =  (enrollmentData, token) => {
    return new Promise((resolve, reject) => {
        let headerdata = {
            headers: {
                'authorization': token,
                'Content-Type': 'application/json'
            }
          }
        axiosraw.post(config.basePath + 'enrollment/getenrollmentpagedata', enrollmentData, headerdata).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}


let getEnrollmentPageDateExcel =  (enrollmentData) => {
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'enrollment/getenrollmentexceldata', enrollmentData).then(result => {
            resolve(result)
        }).catch((err) => {

            if(err && err.response && err.response.data && err.response.data && err.response.data.message){
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to fetch enrollment data"
                })
            }
        })
    })
}


const costEstimateService = {
    getEnrollmentPageDate,
    saveEnrollmentPageData,
    getEnrollmentPageDatePDF,
    getEnrollmentPageDateExcel
}

export default costEstimateService 